<!-- Translated: yes -->
<template>
  <div class="buttons">
    <button v-if="show('accomodation')" :class="'medium white border checkout' + (has('accomodations', true) ? ' checked' : '')" @click="goTo('/boenden')">
      <icon name="boende" :scale="3.2" />{{ $t('general.cta.book-thing', {thing: $t('general.accomodation')}) }}
      <icon class="punktlista" v-if="has('accomodations', true)" name="punklista-check" :scale="1.5" />
      <icon v-if="has('accomodations', true)" name="green-dark-check" :scale="2" />
    </button>

    <button v-if="show('skiletting') && !add && !has('accomodations', true)" :class="'medium white border checkout' + (has('rentals', true) ? ' checked' : '')" @click="goTo('/skidhyra', false, true)">
      <icon name="utrustning" :scale="3.2" />{{ $t('general.cta.book-thing', {thing: $t('general.equipment')}) }}
      <icon class="punktlista" v-if="has('rentals', true)" name="punklista-check" :scale="1.5" />
      <icon v-if="has('rentals', true)" name="green-dark-check" :scale="2" />
    </button>

    <button v-if="show('skiletting') && !add && has('accomodations', true)" :class="'medium white border checkout' + (has('rentals', true) ? ' checked' : '')" @click="goTo('/skidhyra?quick=1&delivery=1', false, true)">
      <icon name="utrustning" :scale="3.2" />{{ $t('general.cta.book-thing', {thing: $t('general.equipment')}) }}
      <icon class="punktlista" v-if="has('rentals', true)" name="punklista-check" :scale="1.5" />
      <icon v-if="has('rentals', true)" name="green-dark-check" :scale="2" />
    </button>

    <button v-if="show('skiletting') && add" :class="'medium white border checkout' + (has('rentals', true) ? ' checked' : '')" @click="goTo('/skidhyra?quick=1')">
      <icon name="utrustning" :scale="3.2" />{{ $t('general.cta.book-thing', {thing: $t('general.equipment')}) }}
      <icon class="punktlista" v-if="has('rentals', true)" name="punklista-check" :scale="1.5" />
      <icon v-if="has('rentals', true)" name="green-dark-check" :scale="2" />
    </button>

    <button v-if="show('skiletting') && add" :class="'medium white border checkout' + (has('rentals', true) ? ' checked' : '')" @click="goTo('/skidhyra?quick=1&delivery=1')">
      <icon name="utrustning" :scale="3.2" />{{ $t('skirental.book-with-delivery') }}
      <icon class="punktlista" v-if="has('rentals', true)" name="punklista-check" :scale="1.5" />
      <icon v-if="has('rentals', true)" name="green-dark-check" :scale="2" />
    </button>

    <button v-if="show('skipass') && !has('products')" :class="'medium white border checkout' + (has('skipasses', true) ? ' checked' : '')" @click="goTo('/liftkort?quick=1')">
      <icon name="liftkort" :scale="3.2" />{{ $t('general.cta.book-thing', {thing: $t('general.skipass')}) }}
      <icon class="punktlista" v-if="has('skipasses', true)" name="punklista-check" :scale="1.5" />
      <icon v-if="has('skipasses', true)" name="green-dark-check" :scale="2" />
    </button>

    <!-- <button v-if="show('keycard')" :class="'medium white border checkout' + (has('skipasses', true) ? ' checked' : '')" @click="goTo('/liftkort?quick=1&onlykeycard=1')">
      <icon name="liftkort" :scale="3.2" />{{ 'Laddningsbart liftkort' }}
      <icon class="punktlista" v-if="has('skipasses', true)" name="punklista-check" :scale="1.5" />
      <icon v-if="has('products', true)" name="green-dark-check" :scale="2" />
    </button> -->

    <button v-if="show('school')" :class="'medium white border checkout' + (has('skischools', false) ? ' checked' : '')" @click="goTo('/skidskola/oversikt?type=group')">
      <icon name="skidskola" :scale="3.2" />{{ $t('general.cta.book-thing', {thing: $t('general.school')}) }}
      <icon class="punktlista" v-if="has('skischools', false)" name="punklista-check" :scale="1.5" />
      <!-- <icon v-if="has('skischools', false)" name="green-dark-check" :scale="2" /> -->
    </button>

    <button v-if="show('bikeschool')" :class="'medium white border checkout' + (has('bikeschool', false) ? ' checked' : '')" @click="goTo('/cykelskola/oversikt?type=group')">
      <icon name="biking-white" :scale="3.2" />{{ $t('general.cta.book-thing', {thing: 'Cykelskola'}) }}
      <icon class="punktlista" v-if="has('bikeschools', false)" name="punklista-check" :scale="1.5" />
      <!-- <icon v-if="has('bikeschools', false)" name="green-dark-check" :scale="2" /> -->
    </button>

    <button v-if="show('activities')" :class="'medium white border checkout' + (has('activities', false) ? ' checked' : '')" @click="goTo(null, '/barn-bjornbusen-branas/')">
      <icon name="aktiviteter" :scale="3.2" />{{ $t('general.cta.book-thing', {thing: $t('general.childrenactivities')}) }}
      <icon class="punktlista" v-if="has('activities', false)" name="punklista-check" :scale="1.5" />
      <icon v-if="has('activities', false)" name="green-dark-check" :scale="2" />
    </button>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  props: {
    add: {
      default: false,
    },
    orderNumber: {
      default: '',
    },
    dateStart: {
      default: null,
    },
    dateEnd: {
      default: null,
    },
    orderNumberNumeric: {
      default: 0,
    },
    helperPool: {
      default: '',
    },
    helperUnit: {
      default: '',
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
    ]),
    goTo(path, url, skipAdd) {
      if (this.add && !skipAdd) {
        this.$store.state.cart.addToOrder = {
          number: this.orderNumber,
          numeric: this.orderNumberNumeric,
          dateStart: this.dateStart,
          dateEnd: this.dateEnd,
          helperPool: this.helperPool,
          helperUnit: this.helperUnit,
        };
      } else if (!this.$store.state.cart.addToOrder || !this.$store.state.cart.addToOrder.number) {
        this.$store.state.cart.addToOrder = {};
      }
      this.closeModal();
      if (path) {
        this.$router.push({ path });
      } else {
        window.location.href = url;
      }
    },
    show(what) {
      if (this.isSummer()) {
        if (what === 'accomodation') {
          return true;
        }
        // if (what === 'skipass') {
        //   return true;
        // }
        // if (this.SITE_CONFIG.site === 'kungsberget') {
        //   if (what === 'bikeschool') {
        //     return true;
        //   }
        // }
        return false;
      }
      const accomodations = this.$store.state.cart.accomodations;
      let currentWinter = true;

      if (accomodations.length) {
        const arrival = accomodations[0].period.date_arrival;
        const winterDates = this.SITE_CONFIG.season.winter;

        currentWinter = false;

        if (arrival >= winterDates.start && arrival <= winterDates.end) {
          currentWinter = true;
        }
      }

      if (!currentWinter) {
        if (what === 'accomodation') {
          return true;
        }
        return false;
      }

      if (what === 'keycard') {
        return true;
      }

      if (what === 'skipass') {
        if (this.add) {
          return true;
        }
        return this.SITE_CONFIG.skipass.buy_enabled ||
        (this.SITE_CONFIG.skipass.buy_enabled_when_accomodation_or_rental && (this.has('accomodations', true) || this.has('rentals', true)));
      }

      if (!this.SITE_CONFIG.modules[what]) {
        return false;
      }

      if (!this.SITE_CONFIG.is_open) {
        return false;
      }

      if (!this.SITE_CONFIG.modules_open[what].open) {
        return false;
      }

      return true;
    },
    has(what, confirmed) {
      let checkWhat = what;

      if (what === 'bikeschools') {
        checkWhat = 'skischools';
      }

      if (this.add) {
        return false;
      }
      if (!this.$store.state.cart[checkWhat]) {
        return false;
      }
      return this.$store.state.cart[checkWhat].filter(a => (confirmed ? a.confirmed : true)).length;
    },
    isSummer() {
      const accomodations = this.$store.state.cart.accomodations;
      const skischools = this.$store.state.cart.skischools;
      const summerDates = this.SITE_CONFIG.season.summer;
      let arrival = '';

      if (accomodations.length) {
        arrival = accomodations[0].period.date_arrival;

        if (arrival >= summerDates.start && arrival <= summerDates.end) {
          return true;
        }
      }

      if (skischools.length) {
        arrival = skischools[0].date;

        if (arrival >= summerDates.start && arrival <= summerDates.end) {
          return true;
        }
      }

      return false;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.image
  padding-top: 53px;
  width: 74px;
  float: left;
  background-image: url(https://static.booking.branasgruppen.se/static/img/liftkort.png);
  background-size: 90%;
  background-repeat: no-repeat;
  background-position: left;


.buttons
  margin-top 30px
  margin-bottom 30px
  .icon
    margin-right: 15px
    &.icon--boende
      margin-top -3px
      margin-bottom 3px
  button
    margin-left 10px
    margin-right 10px
    margin-bottom 10px
    position relative
    +max-mobile()
      padding-top 15px
      padding-bottom: 15px

</style>



// WEBPACK FOOTER //
// CompletedBookings.vue?0370f44e